<template>
  <div>
    <monresto-header-child
      :changeName="changeName"
      :currentLang="currentLang"
      :newItem="newItem"
      :restaurant="restaurant ? restaurant : {}"
      :suggestions="suggestions"
      :currentCurrency="currentCurrency"
      @sendItemSelected="handleSelectedItemToTheme"
    />
    <monresto-body-child
      :log="log"
      :functionCollapsed="functionCollapsed"
      :reserved_items="reserved_items"
      :quantities="quantities"
      :indexes="indexes"
      :SubstractQuanity="SubstractQuanity"
      :RemoveItem="RemoveItem"
      :AddQuanity="AddQuanity"
      :newSection="newSection"
      :newItem="newItem"
      :listSections="listSections"
      :restaurant="restaurant ? restaurant : {}"
      :currentTab="currentTab"
      :setCurrentTab="setCurrentTab"
      :changeSectionTitle="changeSectionTitle"
      :changeSectionSubTitle="changeSectionSubTitle"
      :addItem="addItem"
      :newSubSection="newSubSection"
      :handleChangeShowSub="handleChangeShowSub"
      :disponibleItem="disponibleItem"
      :showItem="showItem"
      :changeItemObservation="changeItemObservation"
      :changeItemTitle="changeItemTitle"
      :changeItemPrice="changeItemPrice"
      :editCategorie="editCategorie"
      :deleteSection="deleteSection"
      :editSubCategorie="editSubCategorie"
      :deleteSubSection="deleteSubSection"
      :editItem="editItem"
      :currentCurrency="currentCurrency"
      :deleteItem="deleteItem"
      :addToCart="addToCart"
    />
  </div>
</template>

<script>
import MonrestoHeader1 from "../headers/monresto.vue";
import MonrestoBody1 from "../body/monresto.vue";

export default {
  components: {
    "monresto-header-child": MonrestoHeader1,
    "monresto-body-child": MonrestoBody1
  },
  props: [
    "indexes",
    "reserved_items",
    "quantities",
    "changeName",
    "currentLang",
    "newItem",
    "restaurant",
    "log",
    "functionCollapsed",
    "newSection",
    "listSections",
    "currentTab",
    "setCurrentTab",
    "changeSectionTitle",
    "changeSectionSubTitle",
    "addItem",
    "newSubSection",
    "handleChangeShowSub",
    "disponibleItem",
    "showItem",
    "changeItemObservation",
    "changeItemTitle",
    "changeItemPrice",
    "editCategorie",
    "deleteSection",
    "editSubCategorie",
    "deleteSubSection",
    "editItem",
    "currentCurrency",
    "deleteItem",
    "addToCart",
    "SubstractQuanity",
    "RemoveItem",
    "AddQuanity",
    "suggestions",
    "recievedItem"
  ],
  data() {
    return {};
  },
  watch: {

  },
  methods: {
    handleSelectedItemToTheme(recievedItem) {
      this.$emit('itemSelectedToIndex', recievedItem);
    },
  },
};
</script>

<style></style>
